import React, { useEffect, useState, useRef } from 'react';
import importScript from './importScript';

const meetUser = 'Plone user';
const meetRoom = 'volto-jitsi-block-test-meeting';
var meetDomain = 'meet.jit.si';
var meetOpts = {
    roomName: meetRoom,
    width: '90vw',
    height: '90vh',
    configOverwrite: {
	startWithAudioMuted: true,
	disableModeratorIndicator: true,
	startScreenSharing: false,
	enableEmailInStats: false
    },
    interfaceConfigOverwrite: {
	DISABLE_JOIN_LEAVE_NOTIFICATIONS: true
    },
    userInfo: {
	displayName: meetUser
    }
};

const Meet = React.memo( () => {
    const api = useRef(null);
    importScript('https://meet.jit.si/external_api.js');
    useEffect( () => {
      if( api.current) return; // init only once
      async function setup() {
        if (typeof(JitsiMeetExternalAPI) !== 'undefined') {
          meetOpts.parentNode = document.querySelector('#meet');
          meetOpts.parentNode.innerHTML = '';
          api.current = new JitsiMeetExternalAPI(meetDomain, meetOpts);
        } else {
	  await new Promise(r => setTimeout(r, 500));
	  console.log("Wait longer for Jitsi library to load.");
	  setup();
	}
      }
      setup();
    }, [api]);
    return <div id="meet">
	       ( reload page for conference software )
	   </div>;
});

const JitsiBlockView = (props) => {
    const { data } = props;
    meetDomain = data.meetDomain;
    meetOpts.roomName = data.meetRoom;
    meetOpts.userInfo.displayName = data.meetUser;
    meetOpts.appId = data.meetAppId;
    meetOpts.jwt = data.meetJWT;
    return <div className="block JitsiBlockView">
	       <h2>{data.title}</h2>
	       <div>{data.description}</div>
	       <Meet/>
	   </div>;
};

export default JitsiBlockView;
